import { SuperSimpleCarousel } from "@wss/carousel";
import React from "react";
import { Provider } from "react-redux";
import NotificationCenter from "~/common/Notification/NotificationCenter";
import Store from "~/common/Store";
import { Product } from "~/common/Store/models/ProductListing";
import TopProductsContent from "~/common/TopProductsCarousel/index";
import { ProductListingView } from "~/productListing/ProductBox/AddToCart";
import { Icon } from "@clarkinc/zest-design-system/ui";
import { cls } from "cls";

export type TopProductsPageType = "Category" | "Vendor";

interface Props {
  topProducts: Product[];
  productListingView?: ProductListingView;
  itemWidth?: string;
  pageType: TopProductsPageType;
}

const TopProductsCarousel = ({
  topProducts = [],
  productListingView,
  itemWidth,
  pageType,
}: Props) => (
  <Provider store={Store}>
    <h2 className="wss mt-3 ml-3 xs:ml-0 header-3">Top Products</h2>
    <NotificationCenter />
    <div
      className="bg-white border-gray-200 border-solid border box-border relative w-full xs:rounded"
      data-testid="Carousel Wrapper"
      data-feature-name={`${pageType} - Top Products`}
      data-gtm-component="carousel"
      gtm-carousel-name="Top Products"
    >
      <SuperSimpleCarousel>
        <SuperSimpleCarousel.Previous
          className={cls(
            "hidden bg-white border-r border-solid border-y-0 border-l-0 border-gray-200 shadow-sm h-full w-[33px] px-1-1/2 absolute top-1/2 -translate-y-1/2",
            "focus-visible:border-2",
            "xs:block",
          )}
          key={`prev_${topProducts.length}`}
        >
          <div
            className="h-full absolute top-0 w-4 -right-4"
            style={{ boxShadow: "rgba(0,0,0,0.25) 5px 0 8px -5px inset" }}
          />
          <Icon
            name="ri-arrow-left-s-line"
            className="fill-green-500 w-5 h-5"
          />
        </SuperSimpleCarousel.Previous>
        <SuperSimpleCarousel.Content className="m-0">
          {topProducts.map(
            (product, index) =>
              product && (
                <SuperSimpleCarousel.Item
                  key={product.itemNumber}
                  className={cls(
                    "border-gray-200 border-solid border-0 border-r p-4 scale-100 flex flex-col flex-shrink-0",
                    "last:border-r-0",
                    itemWidth,
                  )}
                >
                  <TopProductsContent
                    key={product.itemNumber}
                    index={index}
                    product={product}
                    mounted
                    productListingView={productListingView}
                  />
                </SuperSimpleCarousel.Item>
              ),
          )}
        </SuperSimpleCarousel.Content>
        <SuperSimpleCarousel.Next
          className={cls(
            "hidden bg-white border-l border-solid border-y-0 border-r-0 border-gray-200 shadow-sm h-full w-[33px] px-1-1/2 absolute top-1/2 -translate-y-1/2",
            "focus-visible:border-2",
            "xs:block",
          )}
          key={`next_${topProducts.length}`}
        >
          <div
            className="h-full absolute top-0 w-4 -left-4"
            style={{ boxShadow: "rgba(0,0,0,0.25) -5px 0 8px -5px inset" }}
          />
          <Icon
            name="ri-arrow-right-s-line"
            className="fill-green-500 w-5 h-5"
          />
        </SuperSimpleCarousel.Next>
      </SuperSimpleCarousel>
    </div>
  </Provider>
);

export default TopProductsCarousel;
